import axios from "axios";
import { getApiConfig } from './config';

class MaintenanceService {
  static async checkMaintenanceStatus() {
    try {
      const response = await axios.get(`/api/maintenance/status`, getApiConfig());
      return response.data;
    } catch (error) {
      console.error('Error checking maintenance status:', error);
      return { inMaintenance: false, data: null };
    }
  }
}

export default MaintenanceService;
